import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["signInTitle", "signUpTitle"];

  updateTitle(e) {
    this.signInTitleTarget.innerText = e.currentTarget.dataset.signInTitle;
    this.signUpTitleTarget.innerText = e.currentTarget.dataset.signUpTitle;
  }
}
